var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejectedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#FDFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.719 11.25c0-4.781-3.938-8.719-8.719-8.719-4.816 0-8.719 3.938-8.719 8.719A8.717 8.717 0 0 0 11 19.969c4.781 0 8.719-3.903 8.719-8.719zM11 13.008c.879 0 1.617.738 1.617 1.617 0 .914-.738 1.617-1.617 1.617a1.591 1.591 0 0 1-1.617-1.617c0-.879.703-1.617 1.617-1.617zM9.453 7.207c-.035-.246.176-.457.422-.457h2.215c.246 0 .457.21.422.457l-.246 4.781c-.036.246-.211.387-.422.387H10.12c-.21 0-.387-.14-.422-.387l-.246-4.781z",
    fill: "#EFAF1E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/rejectedIcon.6f3393a88eb3dfb1cb2ee805ca6fda6a.svg";
export { ForwardRef as ReactComponent };